export default __webpack_public_path__ + "static/media/0x855d4248672a1fce482165e8dbe1207b94b1968a.c085d7a5.webp";